export const GREEK = {
  CHI: 'χ'
};
